import { useTokens } from './theme';
import cupLogo from './cup-logo.png';

// The reserved clay accent (DESIGN.md "Color") — the wordmark's period.
const CLAY = '#E14E2C';

/**
 * The Coffee Chats brand mark — the fun smiley cup (DESIGN.md DEFAULT mark,
 * client/assets/icon.png) plus the "Coffee Chats." wordmark (clay period). WE
 * are the platform; the school is the tenant, so the wordmark stays in brand
 * ink (never the school accent). The cup illustration carries its own colors, so
 * it reads on both the cream portal and the dark console; `color` tints only the
 * wordmark. Shared by both builds; import from '../shared/CupMark'.
 *
 * @param {{ size?: number|string, withWordmark?: boolean, color?: string, wordmarkSize?: number|string }} props
 */
export default function CupMark({ size = 24, withWordmark = false, color, wordmarkSize = 15 }) {
  const t = useTokens();
  const ink = color || t.heading;
  return (
    <span className="inline-flex items-center gap-2 select-none" aria-hidden="true">
      <img
        src={cupLogo}
        alt=""
        width={typeof size === 'number' ? size : undefined}
        height={typeof size === 'number' ? size : undefined}
        style={{ objectFit: 'contain', display: 'block', width: size, height: size }}
      />
      {withWordmark ? (
        <span
          className="shrink-0 whitespace-nowrap leading-none"
          style={{ fontFamily: t.fonts.display, color: ink, fontWeight: 600, fontSize: wordmarkSize }}
        >
          Coffee Chats
          <span style={{ color: CLAY }}>.</span>
        </span>
      ) : null}
    </span>
  );
}
